import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import MenuIcon from "@material-ui/icons/Menu";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
} from "@material-ui/core";
import { navigate, useLocation } from "@reach/router";
import { H2 } from "./Styles";
import styled from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: "auto",
    [theme.breakpoints.up(640)]: {
      minWidth: "64px",
    },
  },
  list: {
    width: "100vw",
    overflow: "auto",
    backgroundColor: "#fff",
  },
  paper: {
    width: "100%",
  },
  padder: {
    paddingTop: "74px",
  },
  sidePadder: {
    paddingLeft: "2%",
    paddingRight: "5%",
    margin: 0,
    boxShadow: "none",
    borderBottom: "1px solid #e8e8e8",
  },
}));

export default function TemporaryDrawer({ title, slug }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const location = useLocation();
  const [openSubMenu, setOpenSubMenu] = useState(null);

  const toggleDrawer = (isOpen) => () => {
    setOpen(isOpen);
  };

  const handleMenuClick = (path) => () => {
    setOpen(false);
    if (path.startsWith("http")) {
      window.open(path, "_blank");
    } else {
      navigate(path);
    }
  };

  const section = location.hash;

  useEffect(() => {
    if (!section) return;

    const redirectMap = {
      ODR: "#odr",
      transcription: "#transcription",
      "case-management": "#case-management",
      "our-offerings": "#our-offerings",
      "enquire-now": "#enquire-now",
    };

    const matchedKey = Object.keys(redirectMap).find((key) =>
      section.includes(key),
    );

    if (matchedKey) {
      navigate(`${location.pathname}${redirectMap[matchedKey]}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section]);

  const toggleSubMenu = (key) => {
    setOpenSubMenu((prev) => (prev === key ? null : key));
  };

  // const list = () => (
  //   <div className={clsx(classes.list, classes.padder)}>
      
      {/* <ExpansionPanel className={classes.sidePadder}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <H2>Webinar</H2>
        </ExpansionPanelSummary>

        <ExpansionPanelDetails style={{ padding: 0 }}>
          <MenuList>
            
            <MenuItem onClick={() => toggleSubMenu("webinar")}>
              Upcoming Webinars
              <Arrow open={openSubMenu === "webinar"} />
            </MenuItem>
            {openSubMenu === "webinar" && (
              <SubMenu>
                <SubMenuItem
                  onClick={handleMenuClick(`/upcoming_webinars/${slug}`)}
                >
                  {title}
                </SubMenuItem>
              </SubMenu>
            )}
            <MenuItem
              onClick={handleMenuClick("/resources/webinar-videos#webinar#one")}
            >
              ODR-Opportunities & Challenges
            </MenuItem>

            <MenuItem
              onClick={handleMenuClick("/resources/webinar-videos#webinar#two")}
            >
              ODR-Evaluation of Section 11 & Section 29A
            </MenuItem>
            <MenuItem onClick={handleMenuClick("/past-webinars")}>
              Past Webinars
            </MenuItem>
          </MenuList>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel className={classes.sidePadder}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <H2>Services</H2>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails style={{ padding: 0 }}>
          <MenuList>
            <MenuItem onClick={handleMenuClick("/#our-offerings")}>
              Arbitrations & Mediations
            </MenuItem>
            <MenuItem onClick={handleMenuClick("/#odr")}>
              ODR Platform Deployments
            </MenuItem>
            <MenuItem onClick={handleMenuClick("/#transcription")}>
              Live Transcription
            </MenuItem>
            <MenuItem onClick={handleMenuClick("/#case-management")}>
              Case Management
            </MenuItem>
           
          </MenuList>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      
      <ExpansionPanel className={classes.sidePadder}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <H2>Resources</H2>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails style={{ padding: 0 }}>
          <MenuList>
            <MenuItem onClick={handleMenuClick("/resources/blogs")}>
              Blogs
            </MenuItem>
            <MenuItem onClick={handleMenuClick("/resources/webinar-videos")}>
              Webinars
            </MenuItem>
            <MenuItem onClick={handleMenuClick("/resources/model-clauses")}>
              Model Clauses
            </MenuItem>
            <MenuItem onClick={() => toggleSubMenu("resources")}>
              Rules
              <Arrow open={openSubMenu === "resources"} />
            </MenuItem>
            {openSubMenu === "resources" && (
              <SubMenu>
                <SubMenuItem onClick={handleMenuClick("/negotiation-rules")}>
                  Negotiation
                </SubMenuItem>
                <SubMenuItem onClick={handleMenuClick("/mediation-rules")}>
                  Mediation
                </SubMenuItem>
                <SubMenuItem onClick={handleMenuClick("/arbitration-rules")}>
                  Arbitration
                </SubMenuItem>
              </SubMenu>
            )}
            <MenuItem onClick={handleMenuClick("/resources/awards")}>
              Awards
            </MenuItem>
          </MenuList>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      
      <ExpansionPanel className={classes.sidePadder}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <H2>Neutrals</H2>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails style={{ padding: 0 }}>
          <MenuList>
            <MenuItem onClick={handleMenuClick("/neutral/arbitrators")}>
              Arbitrators
            </MenuItem>
            <MenuItem onClick={handleMenuClick("/neutral/mediators")}>
              Mediators
            </MenuItem>
            <MenuItem
              onClick={handleMenuClick(process.env.REACT_APP_NEUTRAL_BASE_URL)}
            >
              Login as Neutral
            </MenuItem>
          </MenuList>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      
      <ExpansionPanel className={classes.sidePadder}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <H2>Training</H2>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails style={{ padding: 0 }}>
          <MenuList>
            <MenuItem
              onClick={handleMenuClick("/training/corporate-short-programme")}
            >
              Corporate Short Training
            </MenuItem>
            <MenuItem
              onClick={handleMenuClick(
                "/training/mediation-training-programme",
              )}
            >
              Mediator Training Programme
            </MenuItem>
            <MenuItem onClick={handleMenuClick("/training/world-of-mediation")}>
              World of Mediation
            </MenuItem>
          </MenuList>
        </ExpansionPanelDetails>
      </ExpansionPanel>

     
      <ExpansionPanel className={classes.sidePadder}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <H2>About Us</H2>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails style={{ padding: 0 }}>
          <MenuList>
            <MenuItem onClick={handleMenuClick("/about-us")}>
              About JustAct
            </MenuItem>
            <MenuItem onClick={handleMenuClick("/about-us#our-advantages")}>
              Our Advantages
            </MenuItem>
            <MenuItem onClick={handleMenuClick("/about-us#how-it-works")}>
              How IAMC Works
            </MenuItem>
            <MenuItem onClick={handleMenuClick("/about-us#our-values")}>
              Our Values
            </MenuItem>
            <MenuItem onClick={handleMenuClick("/about-us#board-of-directors")}>
              Board of Directors
            </MenuItem>
            <MenuItem onClick={handleMenuClick("/about-us#management-team")}>
              Management Team
            </MenuItem>
            <MenuItem onClick={handleMenuClick("/about-us#partnerships")}>
              Our Partners
            </MenuItem>
          </MenuList>
        </ExpansionPanelDetails>
      </ExpansionPanel> */}
    {/* </div>
  ); */}

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Container>
        <LoginDiv onClick={handleMenuClick("/login")}>
          <p>Login</p>
        </LoginDiv>
        <LoginDiv
          onClick={() => {
            navigate("#enquire-now");

            {
              const el = document.getElementById("enquire-now");
              if (el) {
                el.scrollIntoView({ behavior: "smooth" });
              }
            }
          }}
        >
          <p> GetInTouch</p>
        </LoginDiv>
      </Container>

      {/* <Button
        className={classes.root}
        onClick={toggleDrawer(!open)}
        aria-label="menu"
      >
        <MenuIcon />
      </Button> */}

      {/* <Drawer
        anchor="top"
        open={open}
        onClose={toggleDrawer(false)}
        classes={{ paper: classes.list }}
        ModalProps={{
          keepMounted: true,
        }}
        style={{ zIndex: "7" }}
      >
        {list()}
      </Drawer> */}

      {/* <Drawer
        anchor="top"
        open={open}
        onClose={toggleDrawer(false)}
        classes={{ paper: classes.paper }}
        ModalProps={{ keepMounted: true }}
      >
        {list()}
      </Drawer> */}
    </div>
  );
}

const MenuList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const MenuItem = styled.div`
  display: flex;
  padding: 16px 20px;
  font-family: ${theme.fonts.primaryFontRegular};
  font-size: 16px;
  cursor: pointer;
  color: ${COLORS.COLOR_DARK};
  border-bottom: 1px solid #e8e8e8;
  align-items: center;
  &:active {
    background-color: #f5f5f5;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const LoginDiv = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: ${COLORS.COLOR_DARK};
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer;
  transition: color 350ms;
  &:hover {
    color: ${COLORS.BTN_GREEN};
  }
  &:first-child {
    margin-right: 15px;
  }
  @media (min-width: 500px) {
    font-size: 16px;
    margin-right: 20px;
    &:first-child {
      margin-right: 35px;
    }
  }
`;

const Arrow = styled(ChevronRightIcon)`
  font-size: 20px !important;
  transition: transform 0.3s ease;
  transform: ${({ open }) => (open ? "rotate(90deg)" : "rotate(0deg)")};
`;

const SubMenu = styled.div`
  background-color: #f9f9f9;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
`;

const SubMenuItem = styled.div`
  padding: 14px 20px 14px 50px;
  font-family: ${theme.fonts.primaryFontRegular};
  font-size: 15px;
  color: ${COLORS.COLOR_DARK};
  cursor: pointer;
  background-color: #f9f9f9;
  border-bottom: 1px solid #e8e8e8;
  &:active {
    background-color: #f0f0f0;
  }
`;
